var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.isSuccess ? _vm.$style.itemSuccess : _vm.$style.itemFailure },
    [
      _c("div", { class: _vm.$style.itemName }, [_vm._v(_vm._s(_vm.name))]),
      _c("div", { class: _vm.$style.itemStatus }, [
        _c("div", { class: _vm.$style.itemStatusText }, [
          _c("h1", { class: _vm.$style.itemStatusLabel }, [
            _vm._v(_vm._s(_vm.status)),
          ]),
          _vm.at
            ? _c("h2", { class: _vm.$style.itemStatusAt }, [
                _vm._v(_vm._s(_vm.at)),
              ])
            : _vm._e(),
        ]),
        _vm.isSuccess
          ? _c(
              "div",
              {
                staticClass: "material-icons",
                class: _vm.$style.successStatusIcon,
              },
              [_vm._v("check_circle")]
            )
          : _c(
              "div",
              {
                staticClass: "material-icons",
                class: _vm.$style.failureStatusIcon,
              },
              [_vm._v("info")]
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }